import { render, staticRenderFns } from "./Carroussel.vue?vue&type=template&id=807c5cde"
import script from "./Carroussel.vue?vue&type=script&lang=js"
export * from "./Carroussel.vue?vue&type=script&lang=js"
import style0 from "./Carroussel.vue?vue&type=style&index=0&id=807c5cde&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports